import React from "react";
// import "./SharedDiv.css";

export default function SharedDiv(props) {
  return (
    /* 
    props
    showTitle = true , false
    titleName = ""
    child = [component structure]
    redboxshadow = true , false
    
    */

    <div
      className={`container ${
        props.redboxshadow ? "red-box-shadow" : "container"
      }`}
    >
      <div className="Subcontainer">
        {props.showTitle && (
          <div className="title-container" >
            <p className="title" id={props.id_Title}>{props.titleName}

            {props.showButton && props.buttonComponent}
            </p>
           
          </div>
        )}
        {props.child}
      </div>
    </div>
  );
}
